export default function getFlatWhenArray(when) {
  if (!['and', 'or'].includes(when.operation)) {
    return [when]
  }

  // insert operator in between all items
  return when.args
    .flatMap((item) => {
      return [{ type: 'operator', operator: when.operation }].concat(
        getFlatWhenArray(item)
      )
    })
    .slice(1)
}
